import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import MangaDetailPage from "../pages/manga/detail/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:genreId", element: <CategoryPage /> },
      { path: "manga/:mangaId", element: <MangaDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;